import { render, staticRenderFns } from "./ProfileWidget.vue?vue&type=template&id=2aee5bb2&scoped=true&"
import script from "./ProfileWidget.vue?vue&type=script&lang=ts&"
export * from "./ProfileWidget.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileWidget.vue?vue&type=style&index=0&id=2aee5bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aee5bb2",
  null
  
)

export default component.exports